/**
 * @file TrainingLayout.jsx
 * @description Componente modular para la sección de Capacitaciones y Asesorías.
 */
//import { motion } from "framer-motion";
import { ShoppingCart, GraduationCap, CheckCircle2 } from "lucide-react";

const TrainingLayout = ({ data, onAddToQuotation }) => {
  if (!data) return null;

  return (
    <div className="space-y-16">
      <header className="space-y-6">
        <div className="inline-flex items-center gap-2 bg-brand-soft/30 px-4 py-2 rounded-xl text-brand-primary font-bold text-xs uppercase tracking-widest">
          <GraduationCap size={16} /> {data.sidebarTitle}
        </div>
        <h2 className="font-display text-4xl font-black text-brand-dark leading-tight">
          {data.header.mainTitle}
        </h2>
        <p className="font-body text-xl text-brand-dark/70 font-light italic border-l-4 border-brand-accent pl-8">
          {data.header.description}
        </p>
      </header>

      <div className="space-y-12">
        {data.blocks.map((block) => (
          <div key={block.id} className="p-8 bg-[#f8faf9] rounded-[40px] border border-brand-soft shadow-sm hover:shadow-xl transition-all relative overflow-hidden group">
            <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
              <h3 className="font-display text-2xl font-black text-brand-dark group-hover:text-brand-primary transition-colors">
                {block.title}
              </h3>
              {block.quotableAll && (
                <button 
                  onClick={() => onAddToQuotation(block, "Capacitación")}
                  className="bg-brand-accent text-brand-dark px-6 py-2 rounded-full font-bold text-[10px] uppercase tracking-widest flex items-center gap-2 hover:bg-brand-dark hover:text-white transition-all shadow-md"
                >
                  <ShoppingCart size={14} /> {block.bundleLabel || "Cotizar Sección"}
                </button>
              )}
            </div>

            <div className="grid gap-6">
              {block.items.map((item) => (
                <div key={item.id} className="bg-white p-6 rounded-3xl border border-transparent hover:border-brand-soft transition-all">
                  <div className="flex items-start justify-between gap-4 mb-4">
                    <h4 className="font-bold text-brand-dark text-lg leading-snug">{item.name}</h4>
                    {item.quotable && (
                      <button 
                        onClick={() => onAddToQuotation(item, block.title)}
                        className="p-2 bg-brand-soft/50 text-brand-primary rounded-xl hover:bg-brand-accent hover:text-brand-dark transition-all"
                      >
                        <ShoppingCart size={18} />
                      </button>
                    )}
                  </div>
                  {item.details.length > 0 && (
                    <ul className="space-y-3">
                      {item.details.map((detail, idx) => (
                        <li key={idx} className="flex gap-3 text-brand-dark/70 text-sm">
                          <div className="w-1.5 h-1.5 rounded-full bg-brand-accent mt-1.5 shrink-0" />
                          {detail}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* PROPUESTA DE VALOR */}
      <div className="bg-brand-dark p-10 md:p-14 rounded-[60px] text-white shadow-2xl relative overflow-hidden">
        <div className="absolute top-0 right-0 w-64 h-64 bg-brand-accent/5 blur-3xl rounded-full" />
        <h3 className="font-display text-3xl font-black mb-10 relative z-10">{data.valueProposition.title}</h3>
        <div className="grid md:grid-cols-2 gap-8 relative z-10">
          {data.valueProposition.points.map((point, i) => (
            <div key={i} className="flex gap-4 items-start group">
              <CheckCircle2 className="text-brand-accent shrink-0 group-hover:scale-125 transition-transform" size={24} />
              <p className="text-white/80 font-medium leading-relaxed">{point}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrainingLayout;